module.exports = __webpack_public_path__ + "img/greg-washington-sq.3f5e6a0f.png";